<template>
  <modal name="modal-nova-formula" :adaptive="true" height="auto" :maxWidth="540" :clickToClose="true" @closed="$emit('closed')">
    <div class="mnf-root">
      <h3 class="mnf-title">Criar Nova Fórmula</h3>
      <p class="mnf-desc">Escolha como deseja iniciar</p>

      <div class="mnf-cards">
        <div class="mnf-card" @click="$emit('ia')">
          <div class="mnf-card-icon mnf-icon-ia">
            <fa-icon icon="magic" />
          </div>
          <h4>Iniciar com IA</h4>
          <p>Descreva o que deseja e a IA gera a fórmula automaticamente</p>
        </div>

        <div class="mnf-card" @click="$emit('manual')">
          <div class="mnf-card-icon mnf-icon-manual">
            <fa-icon icon="pencil-alt" />
          </div>
          <h4>Criar Manualmente</h4>
          <p>Monte a fórmula do zero, etapa por etapa no editor visual</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "ModalNovaFormula",
};
</script>

<style scoped>
.mnf-root { padding: 32px; text-align: center; }
.mnf-title { font-size: 1.2rem; font-weight: 700; color: #1f2937; margin: 0 0 4px; }
.mnf-desc { font-size: 0.85rem; color: #9ca3af; margin: 0 0 24px; }

.mnf-cards { display: flex; gap: 16px; justify-content: center; }

.mnf-card {
  flex: 1; max-width: 220px;
  padding: 24px 16px;
  border: 2px dashed #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}
.mnf-card:hover {
  border-color: #818cf8;
  background: #f5f3ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(99,102,241,0.1);
}

.mnf-card-icon {
  width: 56px; height: 56px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 12px; font-size: 1.2rem;
}
.mnf-icon-ia { background: #ede9fe; color: #7c3aed; }
.mnf-icon-manual { background: #dbeafe; color: #3b82f6; }

.mnf-card h4 { font-size: 0.9rem; font-weight: 600; color: #374151; margin: 0 0 6px; }
.mnf-card p { font-size: 0.75rem; color: #9ca3af; margin: 0; line-height: 1.4; }
</style>
